import { render } from "./MessagePage.vue?vue&type=template&id=e1794b68&scoped=true"
import script from "./MessagePage.vue?vue&type=script&lang=js"
export * from "./MessagePage.vue?vue&type=script&lang=js"

import "./MessagePage.vue?vue&type=style&index=0&id=e1794b68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1794b68"]])

export default __exports__